import { ApiError } from "@/lib/api";

/**
 * The API's code for a tenant that has never finished a scan (409). It is the
 * normal state of a tenant that was just added, so it is not rendered as a
 * failure. It is not rendered as an empty or clean result either: the panel
 * says plainly that nothing has been measured, hatched like every other
 * not-measured state, and names the next step.
 */
export const NO_FINISHED_SCAN = "no_finished_scan";

export function isNoFinishedScan(error: unknown): boolean {
  return error instanceof ApiError && error.code === NO_FINISHED_SCAN;
}
